import type { DocMigration } from "../docMigration";

/**
 * Moves underlays with `planType === "ROOF"` into a new `roofUnderlays` table
 * and strips `planType` from all remaining underlays.
 */
const migration: DocMigration = {
  id: "20260605_roof_underlays_table",
  description: "Move roof-plan underlays into a dedicated roofUnderlays table, remove planType field",
  apply(json) {
    if (!json.underlays) {
      json.roofUnderlays = {};
      return json;
    }

    json.roofUnderlays = {};

    const nextUnderlays: Record<string, unknown> = {};
    for (const [id, underlay] of Object.entries(json.underlays as Record<string, any>)) {
      const entry = { ...underlay };
      delete entry.planType;
      if (underlay?.planType === "ROOF") {
        json.roofUnderlays[id] = entry;
      } else {
        nextUnderlays[id] = entry;
      }
    }

    json.underlays = nextUnderlays;
    return json;
  },
};

export default migration;
